var formMode;
function trackLandingEvent(name) {
  let dataLayer = window.dataLayer = window.dataLayer || [];
  let landingtest = {
    pageType: 'LandingConsent',
    event: 'Consent3-' + formMode + '-' + name
  };
  dataLayer.push(landingtest);
}

$(document).ready(() => {

  let samplePagePath = "/products/sample-kit";



  // ********************
  // VALIDATE IOS VERSION
  // ********************
  (() => {
    let ios_version;
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      const version_extract = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      ios_version = parseInt(version_extract[1], 10);
    }
    if(ios_version < 10) {
      // alert('OLD iOS')
      window.location.assign(samplePagePath); 
    }
  })()
  


  // *********
  // ACCORDION
  // *********
  $('#accordion').find('.accordion-toggle').click(function() {
    var content = $(this).closest('.question-item').find('.accordion-content');
    var icon = $(this).closest('.question-item').find('.accordion-icon');

    content.slideToggle('fast');
    icon.addClass('ac-icon-plus').toggleClass('ac-icon-minus')

    $(".accordion-content").not(content).slideUp('fast');
    $(".accordion-icon").not(icon).addClass('ac-icon-plus').removeClass('ac-icon-minus');
  });




  // ***********
  // TRIO SELECT
  // ***********

  $('#trio-select').on('change', function () {
    const skin_type = $(this).val();
    const type = $(this).data('type');
    const accessory = $(this).data('accessory');
    const accessorySkin_Type = $(this).data('skin-type-id');
    var shop_url = `https://www.riversol.com/products/${type === 'Redness Control' ? 'redness-control' : 'anti-aging'}-` + skin_type;
    if (typeof accessory !== "undefined") {
    var shop_url = `https://www.riversol.com/products/${type === 'Redness Control' ? 'redness-control' : 'anti-aging'}-trio-` + accessory + "-" + skin_type;      
    }
    $('.routine-body .skin-type-w').removeClass('unselected-trio');
    $('.trio-description').removeClass().addClass('trio-description d-flex ' + skin_type);
    $('.select-button a').prop('href', shop_url);
    $('.select-button').removeClass('d-none');
  });


  // **********
  // LAZY SIZES
  // **********
  lazySizes.init();



  // ********************
  // SPECIAL MODALS ACTION
  // ********************

  $('#btn-drrivers-modal').on('click', function(e) {
    e.preventDefault();
    $('.landing-modals').modal('hide');
    $('#modal-routine').modal('show');
  })

  $(".content-tiles section").on('click', function() {
    const content = $(this).find('.modal-content-text').html();
    $("#modal-generic .modal-container").html(content);
  })

  // *****************
  // ACCESS VALIDATION
  // *****************

  const getGeoData = (async () => {
    if (Geolizr && !window.geoData) {
      window.geoData = await new Promise((resolve) => { Geolizr.getGeoData(gl => resolve(gl))});
      validateAccess();

      let countryCode = window.geoData ? window.geoData.countryCode : 'CA';
      formMode = countryCode || 'CA'

      // initConsent();
    } else {
      setTimeout(getGeoData(), 1000);
    }
  })()

  function initConsent() {
    let countryCode = window.geoData ? window.geoData.countryCode : 'CA';
    if (countryCode == "US") {
      // formMode = "US";
      // $('.consent-on').detach();
      // return;

      let randomNum = Math.floor(Math.random() * 2);
      if (randomNum == 0) { // 50%
        formMode = "US-Consent";
        $('.consent-off').detach();
      } else if (randomNum == 1) { // 50%
        formMode = "US-Normal";
        $('.consent-on').detach();
      }
    } else {
      //CA
      formMode = "CA";
      $('.consent-on').detach();
    }
    trackLandingEvent("View");
  }

  const validateAccess = () => {
    
    const safeAccess = JSON.parse(sessionStorage.getItem('safeAccess')); 
    const gl = window.geoData;
    const intl = gl && (gl.countryCode !== 'CA' && gl.countryCode !== 'US');

    // We are checking if safeAccess = false only.
    // if safeAccess = NULL, it means that the blacklist wasn't verified yet, but it's okay to pass it by
    if(safeAccess === false || intl) {
      // alert(`Safe access: ${safeAccess}  | gl: ${!!gl}  | intl: ${intl}`)
      window.location.assign(samplePagePath);
      return
    } 
  }


  // *****************
  // SAMPLE FORM MODAL
  // *****************
  let trackFormOnce = true;
  const openModal = () => {
    const countryCodeAC = window.geoData?.countryCode ?? 'US';
    window.pca?.addressComplete?.setCountry(countryCodeAC);
  
    try {
      window.pca?.addressComplete?.controls[0].listen("populate", function (address) {
        if(!window.newSampleForm) {
          checkInputs(['ac-streetname_1','locality_1','ac-region_1','postal_code_1']);
        }
      });
    } catch(e) {
      console.log(e);
    }

    if(window.newSampleForm) {
      $('#modal-new-form').modal({backdrop: 'static', keyboard: false}, 'show');
    } else {
      if (trackFormOnce) {
        trackLandingEvent("Form");
        trackFormOnce = false;
  
        initPhoneNumberField();
        
      }
    
      window.openModalScrollTop = $(window).scrollTop();
    
      $('#fake-modal').removeClass('d-none');
      $('#page-content').addClass('d-none');

      $('body').addClass('fake-modal-open'); 
      $('.error-screen').hide();
      $('.fake-modal').removeClass('error');

      $(window).scrollTop(0);
    }
    
  }

  const closeModal = () => {
    $('#fake-modal').addClass('d-none');
    $('#page-content').removeClass('d-none');
    
    $('body').removeClass('fake-modal-open');
    $(window).scrollTop(window.openModalScrollTop);
  }

  $('.modal-samplekit').on('click', function(e) {
    e.preventDefault();
    validateAccess();
    openModal();
  })

  $('.fake-modal-close').on('click', function(e) {
    e.preventDefault();
    closeModal();
  })


  // **********************
  // MOBILE IMAGES CAROUSEL
  // **********************
  function is_touch_device() {
    if (screen.width > 1025) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints; // Checks for existence in all browsers and IE 10/11 & Surface
  }
  
  if (is_touch_device()) {
    $('#mobile-carousel-images').addClass('mobile-carousel-hotfix');
    $('#mobile-carousel-images .flickity-box').addClass('flickity-box-hotfix')
  } else {
    $('#mobile-carousel-images').flickity({
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      autoPlay: false,
      dragThreshold: 0.04,
      freeScrollFriction: 10,
      cellAlign: 'center',
      imagesLoaded: true
    });
  }
  $('#tablet-carousel-images').flickity({
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      autoPlay: false,
      dragThreshold: 0.04,
      freeScrollFriction: 10,
      cellAlign: 'center',
      imagesLoaded: true
  });
    


  // **********************
  // MOBILE IMAGES CAROUSEL
  // **********************

  const initPhoneNumberField = () => {
    const input1 = document.querySelector("#ac-phone_1");
    const countryCode = window.geoData ? window.geoData.countryCode : 'CA';
    window.phoneInput1 = window.intlTelInput(input1, {
      initialCountry: countryCode || 'CA',
      // geoIpLookup: getCountry1,
      preferredCountries: ["us", "ca"],
      onlyCountries: ["ca", "us", "gb", "au", "nz", "ch", "de", "ie", "qa", "fr", "es", "nl", "it", "bn", "ae", "mx", "jp", "cn", "be", "bt", "at", "dk", "sa", "bh", "id", "il", "lt", "bg", "gd", "in", "hk", "ma", "sg", "mu", "kn", "br", "ph", "pl", "kw", "hu", "jm", "lb", "my", "eg", "ng", "ad", "mo", "no", "bm", "pk", "ua", "si", "fi", "gh", "ro", "uy"],
      utilsScript: INTL_TEL_UTILS_SCRIPT,
    });
  }
  
});